<script>
    import moment from 'moment';

    export default {
        name: 'MomentPlugin',
        install: function (Vue, name = '$moment') {
            Object.defineProperty(Vue.prototype, name, { value: moment });
        }
    }
</script>